// if: lines of code > 300
// then: breakdown this file and move to src/features/ExlyConnect/utils folder

import SessionStorageConstants from "constants/SessionStorage.constants";
import { app_route_keys } from "constants/urlPaths";
import { dataProvider } from "data";
import { appendUrlParams, navigateTo } from "utils/urlUtils";
import { EXLY_CONNECT_APIS } from "./ExlyConnect.api";
import { apiMethods } from "data/api.constants";
import { exly_connect_query_param_slot_uuid } from "./ExlyConnect.constants";

export const onTabChange = (_, value) => {
  sessionStorage.setItem(
    SessionStorageConstants.ACTIVE_EXLY_CONNECTED_TAB,
    value
  );
  navigateTo(app_route_keys.exly_connect, { args: value });
  window.location.reload();
};

export const checkUserValidity = async () => {
  return dataProvider.custom_request(
    EXLY_CONNECT_APIS.check_user_validity,
    apiMethods.GET
  );
};

/**
 * Adds slot uuid in the query of joining link
 * @param {string} joining_link joining link for exly zoom webinar
 * @param {string} slot_uuid slot uuid of exly zoom webinar listing
 * @returns final joining link for exly zoom webinar with slot uuid in query params
 */
export const getWebinarHostJoiningLink = (joining_link, slot_uuid) => {
  if (!joining_link || !slot_uuid) {
    return joining_link;
  }
  const creatorLink = new URL(joining_link);
  const nextLink = new URL(creatorLink.searchParams.get("next"));
  creatorLink.searchParams.set(
    "next",
    appendUrlParams(nextLink.href, {
      [exly_connect_query_param_slot_uuid]: slot_uuid,
    })
  );
  return creatorLink.href;
};
